<template>
    <div
        id="app"
        :class="{
            'no-left-menu': $route.meta.gnbShow == false,
            'touch-app': $route.meta.isTouch == true,
            pc: $route.meta.gnbType !== null && $route.meta.gnbType !== undefined,
        }"
    >
        <div style="display: flex">
            <navigation v-if="$route.meta.gnbShow !== false && isShowCareMenu"></navigation>
            <center-navigation v-else-if="$route.meta.gnbShow !== false"></center-navigation>

            <div style="width: 100%">
                <div
                    class="header-wrap"
                    v-if="$route.meta.gnbShow !== false && isShowCareMenu"
                    style="width: 100%; flex-shrink: 0"
                ></div>
                <topSearch v-else-if="$route.meta.gnbShow !== false"></topSearch>

                <div v-if="$route.meta.gnbShow !== false" style="height: 3rem">
                    <breadcrumb></breadcrumb>
                </div>

                <div
                    v-if="$route.meta.gnbType === null || $route.meta.gnbType === undefined"
                    class="wrapper"
                    style="padding: 1.6rem 3.2rem 3.2rem 3.2rem; min-height: 50%"
                >
                    <keep-alive>
                        <router-view :key="$route.fullPath + (centerId || '')" class="content" v-if="$route.meta.keepAlive" />
                    </keep-alive>
                    <router-view :key="$route.fullPath" class="content" v-if="!$route.meta.keepAlive" />
                </div>

                <div v-if="$route.meta.gnbType !== null && $route.meta.gnbType !== undefined" class="wrapper mobile">
                    <div v-if="$route.meta.gnbShow !== false" style="height: 3rem">
                        <breadcrumb></breadcrumb>
                    </div>
                    <router-view :key="$route.fullPath" class="content"></router-view>
                </div>
            </div>
        </div>

        <portal-target name="modals" multiple></portal-target>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue';
import CenterNavigation from '@/components/CenterNavigation.vue';
import {mapGetters} from 'vuex';

export default {
    components: {
        Navigation,
        CenterNavigation,
    },
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
        isShowCareMenu() {
            const { getters } = this.$store;
            return getters['auth/isCareAdmin'] || getters['auth/isSystemAdmin'];
        },
    },
    mounted() {
        this.$nextTick(() => {
            // console.log(this.$route.meta.gnbShow);
        });
    },
};
</script>

<style lang="scss"></style>
